import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clearAllLabel: {
    id: 'GMSHIL',
    defaultMessage: 'Clear all',
    description: 'Link to clear all fields in a WWEX registration edit sub-view',
  },
});
